// import Cookies from "js-cookie";

// export const baseUrl = process.env.REACT_APP_API + "/api";

// export const getAuthHeader = () => {
//   const token = Cookies.get("login_token");
//   return {
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//   };
// };

// // auth
// export const HISTORICAL_DATA_URL = baseUrl + "/cbm/aggregate";

import Cookies from "js-cookie";

export const baseUrl = process.env.REACT_APP_API + "/api";

export const getAuthHeader = () => {
  const token = Cookies.get("login_token");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

// auth
export const HISTORICAL_DATA_URL = baseUrl + "/cbm/aggregate";